import { gql } from "@apollo/client";

// One department with its members, for TeamEditDialog: saving the dialog
// sends its member list in full, so it has to start from the saved one.
export default gql`
  query getOrganizationTeamQuery($teamId: Int!) {
    team(teamId: $teamId) {
      id
      title
      members(orderBy: "name") {
        totalCount
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
    }
  }
`;
